export const generateAvatar = (node: HTMLImageElement, initials: string) => {
    // Create a canvas element.
    const canvas = document.createElement('canvas') as HTMLCanvasElement;
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

    // Set the canvas size.
    const size = 24;
    canvas.width = size;
    canvas.height = size;

    // Generate a random color.
    const randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);

    // Fill the canvas with the random color.
    ctx.fillStyle = randomColor;

    // Draw a circle
    ctx.beginPath();
    ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
    ctx.fill();

    // Draw the initials on the canvas.
    ctx.fillStyle = '#ffffff';
    ctx.font = 'bold 12px Arial'; // Adjust font size if needed
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(initials, canvas.width / 2, canvas.height / 2);

    // Set the canvas as an image source on the node.
    node.src = canvas.toDataURL();
};